import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";

export const InputColorStyles = (theme: Theme) => createStyles({

    root_inherit: {
        color: 'inherit',
    },
    root_white: {
        color: theme.palette.common.white
    },
    root_black: {
        color: theme.palette.common.black
    },
    root_primary: {
        color: theme.palette.primary.dark
    },
    root_secondary: {
        color: theme.palette.secondary.dark
    },
    root_error: {
        color: theme.palette.error.dark
    },
    root_warning: {
        color: theme.genie.palette.warning.dark
    },
    root_info: {
        color: theme.genie.palette.info.dark
    },
    root_success: {
        color: theme.genie.palette.success.dark
    },
    root_muted: {
        color: theme.genie.palette.muted.main
    },
    root_mutedDark: {
        color: theme.genie.palette.muted.dark
    },
    root_mutedLight: {
        color: theme.genie.palette.muted.light
    },

    under: {
        "&:after": {
            borderBottomWidth: "1",
            borderBottomStyle: "solid"
        }
    },
    under_inherit: {
        "&:after": {
            borderBottomColor: "inherit"
        }
    },
    under_white: {
        "&:after": {
            borderBottomColor: theme.palette.common.white
        }
    },
    under_black: {
        "&:after": {
            borderBottomColor: theme.palette.common.black
        }
    },
    under_primary: {
        "&:after": {
            borderBottomColor: theme.palette.primary.dark
        }
    },
    under_secondary: {
        "&:after": {
            borderBottomColor: theme.palette.secondary.dark
        }
    },
    under_error: {
        "&:after": {
            borderBottomColor: theme.palette.error.dark
        }
    },
    under_warning: {
        "&:after": {
            borderBottomColor: theme.genie.palette.warning.dark
        }
    },
    under_info: {
        "&:after": {
            borderBottomColor: theme.genie.palette.info.dark
        }
    },
    under_success: {
        "&:after": {
            borderBottomColor: theme.genie.palette.success.dark
        }
    },
    under_muted: {
        borderBottomColor: theme.genie.palette.muted.main
    },
    under_mutedDark: {
        borderBottomColor: theme.genie.palette.muted.dark
    },
    under_mutedLight: {
        borderBottomColor: theme.genie.palette.muted.light
    },
});